
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import MobileNavbar from "./MobileNavbar";
import TopMenu from "./TopMenu";
import Footer from "./Footer";
import ChatbotAssistant from "@/components/chatbot/ChatbotAssistant";
import PremiumUpgradePopup from "@/components/premium/PremiumUpgradePopup";
import DisclaimerDialog from "@/components/disclaimer/DisclaimerDialog";
import Division240Reminder from "@/components/inventaire/Division240Reminder";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  
  // Ne plus réinitialiser le flag à chaque changement de page - le popup ne s'affiche qu'une seule fois par session
  
  return (
    <div className="min-h-screen bg-nautic-background flex flex-col overflow-x-hidden">
      <TopMenu />
      
      <div className="flex flex-1 pt-16 min-w-0">
        <main className={`flex-1 min-w-0 w-full overflow-x-hidden main-content md:px-6 lg:px-8 ${isMobile ? 'pb-20' : 'p-4'}`}>
          {children}
        </main>
      </div>
      
      <Footer />
      
      {isMobile && <MobileNavbar />}
      
      <PremiumUpgradePopup />
      <DisclaimerDialog />
      <Division240Reminder />
    </div>
  );
};

export default MainLayout;
